<template>
  <a-spin :spinning="loading">
    <a-alert banner :show-icon="false" v-if="signupData.signCostStatus !== ''">
      <span slot="message">{{ getPayType() }}<a-icon type="question-circle" style="margin-left: 10px;" @click="showModelData()"/></span>
    </a-alert>
    <a-collapse v-if="signupData.combats.length > 0">
      <a-collapse-panel :key="combatIndex" v-for="(combat, combatIndex) in signupData.combats">
        <div slot="header" class="header">
          <div class="team">
            <span class="teamName">{{ combat.name }}</span>
          </div>
          <div class="teamData">
            <a-tag color="#2db7f5">参赛人数：{{ combat.playerNumber }}人</a-tag>
            <a-tag :color="combat.unPayPlayerNumber === 0 ? '#87d068' : '#f50'">{{ signupData.signCostStatus == 'FREE' ? '免报名费' : (combat.unPayPlayerNumber == 0 ? '已缴费' : '未缴费：' + combat.unPayPlayerNumber + '人') }}</a-tag>
          </div>
        </div>
        <a-collapse>
          <a-collapse-panel v-for="(team, teamIndex) in combat.teams" :key="teamIndex">
            <div slot="header" class="header">
              <div style="display: flex; justify-content: flex-start;align-items: center;">
                <div class="team">
                  <img :src="team.teamLogo || defaultImg"/>
                  <span class="teamName">{{ team.teamName }}</span>
                </div>
                <div class="teamData">
                  <a-tag color="#87d068">参赛人数：{{ team.playerNumber}}人</a-tag>
                  <a-tag :color="team.unPayPlayerNumber === 0 ? '#87d068' : '#f50'">{{ signupData.signCostStatus == 'FREE' ? '免报名费' : (team.unPayPlayerNumber == 0 ? '已缴费' : '未缴费：' + team.unPayPlayerNumber + '人') }}</a-tag>
                </div>
              </div>
              <div>
                <a-popconfirm
                  title="确定删除该队伍的参赛信息?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm.stop="delTeam(combat, team, record, combatIndex, teamIndex,)">
                  <a-button size="small" @click.stop="">删除</a-button>
                </a-popconfirm>
              </div>
            </div>
            <a-table
              :columns="playerColumns"
              :data-source="team.players"
              size="small"
              :pagination="false">
              <div class="player" slot="name" slot-scope="text, record">
                <img :src="record.head || defaultHead"/>
                <span>{{ record.name }}</span>
              </div>
              <a-tag :color="text == 1 ? '#87d068' : '#f50'" slot="status" slot-scope="text">{{ signupData.signCostStatus == 'FREE' ? '免报名费' : text === 1 ? '已购买' : '未购买' }}</a-tag>
              <div slot="action" slot-scope="text, record, index">
                <a-popconfirm
                  title="确定要删除该队员的参赛信息?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="delPlayer(combat, team, record, combatIndex, teamIndex, index)">
                  <a-button size="small">删除</a-button>
                </a-popconfirm>
              </div>
            </a-table>
          </a-collapse-panel>
        </a-collapse>
      </a-collapse-panel>
    </a-collapse>
    <div
      v-if="signupData.combats.length > 0 "
      class="footer">
      <a-button icon="calculator" type="primary" :disabled="btnDisabled()" @click="buySignUp">{{signupData.signCostStatus === 'FREE' ? '该赛事免报名费' : (btnDisabled() ? '没有需缴费的队员' : '缴纳报名费')}}</a-button>
    </div>
    <a-alert type="warning" v-if="signupData.combats.length === 0" style="width:100%;">
      <div style="margin: 0 auto;" slot="description">
        <a-empty :image="simpleImage">
          <span slot="description">暂无参赛信息</span>
        </a-empty>
      </div>
    </a-alert>
    <SignupPayModelData ref="signupPayModelData"/>
    <PayQrCode ref="payQrCode" @paySuccess="paySuccess"/>
  </a-spin>
</template>
<script>
import { Empty } from 'ant-design-vue'
import SignupPayModelData from '@comm/components/join/pay/SignupPayModelData'
import PayQrCode from '@comm/components/join/pay/PayQrCode'
const playerColumns = [
  { title: '队员', dataIndex: 'name', scopedSlots: { customRender: 'name' } },
  { title: '位置', dataIndex: 'location', scopedSlots: { customRender: 'location' } },
  { title: '球衣号', dataIndex: 'jerseyNumber', scopedSlots: { customRender: 'jerseyNumber' } },
  { title: '缴费状态', dataIndex: 'status', scopedSlots: { customRender: 'status' } },
  { title: '操作', dataIndex: '', scopedSlots: { customRender: 'action' } }
]
export default {
  components: {
    SignupPayModelData,
    PayQrCode
  },
  data () {
    return {
      loading: false,
      defaultImg: require('@comm/assets/join/empty_img.png'),
      defaultHead: require('@comm/assets/join/empty_user.png'),
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
      playerColumns: playerColumns,
      signupData: {
        signCostStatus: '',
        combats: []
      }
    }
  },
  mounted () {
    this.queryBigballSingupData()
  },
  methods: {
    queryBigballSingupData (toNext) {
      let matchId = this.$route.query.matchId
      let agencyId = this.$route.query.agencyId
      let programId = this.$route.query.programId
      this.loading = true
      this.$api.join.queryBigballSingupData(matchId, agencyId, programId).then(res => {
        if (res.status === 0) {
          this.signupData = res.data
          if (toNext) {
            this.$emit('paySuccess')
          }
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log('err', err)
        this.$message.error('获取报名数据失败')
      }).finally(_ => {
        this.loading = false
      })
    },
    delPlayer (combat, team, player, combatIndex, teamIndex, playerIndex) {
      let params = {
        matchId: this.$route.query.matchId,
        combatId: combat.combatId,
        agencyId: this.$route.query.agencyId,
        combatDetailId: combat.combatDetailId,
        cardId: player.cardId,
        teamId: team.teamId,
        teamNumber: 1
      }
      this.loading = true
      this.$api.join.delSmallballJoinPlayer(params).then(res => {
        if (res.status === 0) {
          this.$message.success('删除成功')
          combat.teams[teamIndex].players.splice(playerIndex, 1)
          if (combat.teams[teamIndex].players.length === 0) {
            combat.teams.splice(teamIndex, 1)
          }
          if (combat.teams.length === 0) {
            this.signupData.combats.splice(combatIndex, 1)
          }
          this.$forceUpdate()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log(err)
        this.$message.error('删除失败')
      }).finally(_ => {
        this.loading = false
      })
    },
    // 删除参赛队伍
    delTeam (combat, team, player, combatIndex, teamIndex) {
      let params = {
        matchId: this.$route.query.matchId,
        agencyId: this.$route.query.agencyId,
        combatId: combat.combatId,
        combatDetailId: combat.combatDetailId,
        teamId: team.teamId,
        teamNumber: 1
      }
      this.loading = true
      this.$api.join.delJoinTeam(params).then(res => {
        if (res.status === 0) {
          this.$message.success('删除成功')
          combat.teams.splice(teamIndex, 1)
          if (combat.teams.length === 0) {
            this.signupData.combats.splice(combatIndex, 1)
          }
          this.$forceUpdate()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log(err)
        this.$message.error('删除失败')
      }).finally(_ => {
        this.loading = false
      })
    },
    btnDisabled () {
      for (let i = 0; i < this.signupData.combats.length; i++) {
        let unPayPlayerNumber = this.signupData.combats[i].unPayPlayerNumber
        if (unPayPlayerNumber > 0) {
          return false
        }
      }
      return true
    },
    getPayType () {
      switch (this.signupData.signCostStatus) {
        case 'FREE':
          return '收费模式：免报名费'
        case 'PEOPLECHARGE':
          return '收费模式：按首项 + 加项收费'
        case 'COMBOCHARGE':
          return '收费模式：按项目组合收费'
        case 'TEAMCHARGE':
          return '收费模式：按队伍收费'
        default:
          return '收费模式：未知'
      }
    },
    showModelData () {
      this.$refs.signupPayModelData.show()
    },
    buySignUp () {
      let params = this.createPostParams()
      if (params.players.length === 0) {
        this.$message.error('没有需要缴纳报名费的队员')
        return
      }
      this.loading = true
      this.$api.join.createSignUpOrder(params).then(res => {
        if (res.status === 0) {
          this.$refs.payQrCode.show(res.data)
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log(err)
        this.$message.error('报名订单创建失败')
      }).finally(_ => {
        this.loading = false
      })
    },
    createPostParams () {
      let needPayPlayers = []
      this.signupData.combats.forEach(combat => {
        let teams = combat.teams
        teams.forEach(team => {
          let players = team.players
          players.forEach(player => {
            if (player.status === 0) {
              needPayPlayers.push({ cardId: player.cardId, combatDetailId: combat.combatDetailId, combatId: combat.combatId, teamId: team.teamId })
            }
          })
        })
      })
      let params = {
        matchId: this.$route.query.matchId,
        agencyId: this.$route.query.agencyId,
        payType: 'PC',
        players: needPayPlayers
      }
      return params
    },
    paySuccess () {
      this.queryBigballSingupData(true)
    },
    payOver () {
      // 是否有参赛队员
      if (this.signupData.combats.length === 0) {
        return {
          status: false,
          content: '暂无任何队员参赛，请先完成选手报名'
        }
      }
      // 如果不是免费模式，则判断是否所有的队员参加的所有项目都已经完成了缴费
      if (this.signupData.signCostStatus !== 'FREE') {
        for (let i = 0; i < this.signupData.combats.length; i++) {
          let combat = this.signupData.combats[i]
          for (let j = 0; j < combat.teams.length; j++) {
            let team = combat.teams[j]
            let hasNoPayPlayer = team.players.some(player => player.status === 0)
            if (hasNoPayPlayer) {
              return {
                status: false,
                content: '还有队员未缴纳报名费，请先缴纳报名费！'
              }
            }
          }
        }
        return { status: true }
      }
      return { status: true }
    }
  }
}
</script>
<style lang="scss" scoped>
  /deep/ .ant-collapse-content-box {
    background: #fafafa;
  }
  .header {
    text-align: left;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .team {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      img {
        height: 30px;
        width: 30px;
        border-radius: 15px;
      }
      .teamName {
        font-size: 18px;
        font-weight: bold;
        margin-left: 20px;
        margin-right: 20px;
      }
    }
  }
  .player {
    img {
      height: 50px;
      width: 40px;
    }
    span {
      margin-left: 10px;
      font-size: 16px;
    }
  }
  .footer {
    width: 100%;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 10px;
    text-align: right;
    border: 1px solid #d9d9d9;
    border-radius: 5px;
    background: #fafafa;
  }
</style>



// WEBPACK FOOTER //
// src/comm/components/join/bigBall/SignUpAmount.vue